import { Box, styled } from "@mui/material";
import { colorPickerName } from "../../../../../classes.js";
const SaturationCursor = styled(Box, {
  name: colorPickerName,
  slot: "SaturationCursor",
  overridesResolver: (_props, styles) => [styles.saturationCursor]
})(({ theme }) => ({
  position: "absolute",
  zIndex: 100,
  width: theme.spacing(2),
  height: theme.spacing(2),
  borderRadius: "50%",
  border: `${theme.spacing(0.25)} solid ${(theme.vars ?? theme).palette.common.white}`,
  boxShadow: `0px 1px 3px rgba(0, 0, 0, 0.12), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.2)`,
  cursor: "move",
  transform: `translate(${theme.spacing(-1)}, ${theme.spacing(-1)})`
}));
export {
  SaturationCursor
};
//# sourceMappingURL=SaturationCursor.js.map
